import { render, staticRenderFns } from "./DocumentSpecial.vue?vue&type=template&id=61764491"
import script from "./DocumentSpecial.vue?vue&type=script&lang=js"
export * from "./DocumentSpecial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports